import { useContext } from 'react';
import { TelemetryContext } from './TelemetryContext';
/**
 * __For internal use only!__
 * Get the entire context including callbacks that registers component to first meaningful content
 * The {@link useTelemetry} hook is the public hook to be used by the consumer
 */

export var useInternalTelemetry = function useInternalTelemetry() {
  var context = useContext(TelemetryContext);

  if (!context) {
    throw Error('Telemetry-aware components must be parented by an TelemetryProvider.');
  }

  return context;
};
//# sourceMappingURL=useInternalTelemetry.js.map